import { AuthFacade } from './../../../../facades/auth/authFacade';
declare var StripeCheckout;
import {AfterViewInit, Component, Input, OnDestroy, OnInit, ElementRef, Renderer2} from '@angular/core';
import {Store} from '@node_modules/@ngrx/store';
import * as AuthReducer from '@store/auth/reducers';
import {User} from '@models/user';
import {Program} from '@models/program';
import {CreateProgramSubscriptionComponent} from '@pages/layout/program/program-page/program-payment/create-program-subscription/create-program-subscription.component';
// import {CreatePaymentComponent} from '@pages/layout/payments/payments-page/payments-page.component';
import {MatDialog} from '@node_modules/@angular/material';
import {Subscription} from '@models/subscription';
import {ProgramService} from '@services/program/program.service';
import {UpdateAuthUser} from '@store/auth/actions';
import {ConfirmModalComponent} from '@components/confirm-modal/confirm-modal.component';
import {SubscriptionService} from '@services/subscription/subscription.service';
import {PaymentService} from '@services/payment/payment.service';
import {BehaviorSubject} from '@node_modules/rxjs/internal/BehaviorSubject';
import {Subject} from '@node_modules/rxjs/internal/Subject';
import {ProgramClassesComponent} from '@pages/layout/program/program-page/program-classes/program-classes.component';
import {CustomCarouselComponent} from '@components/custom-carousel/custom-carousel.component';
import * as ProgramReducer from '@store/program/reducers';
import {SetPrograms, UpdateProgram} from '@store/program/actions';
import * as SubscriptionReducer from '@store/subscription/reducers';
import {AttendanceService} from '@services/attendance/attendance.service';
import {TermsComponent} from '@components/terms/terms.component';
import {TermsPdfComponent} from '@components/terms-pdf/terms-pdf.component';
import {ActivatedRoute, Router} from '@node_modules/@angular/router';
import {SchoolService} from '@services/school/school.service';
import {School} from '@models/shool';
import {environment} from '../../../../../environments/environment';
import { data } from 'jquery';
import {EventEmitter, NgZone, Output} from "@node_modules/@angular/core";
import {MessageService} from "@services/message/message.service";
import {AccountService} from "@services/account/account.service";
import {AuthService as AuthServiceSocial} from "@node_modules/angularx-social-login/src/auth.service";
import * as SpinnerReducer from "@store/spinner/reducers";
import {ParentUsersService} from "@services/parentUsers/parent-users.service";
import {FormBuilder} from "@node_modules/@angular/forms";
import {UserValidators} from "@app/user-validators";
import {RechargeFailedChargeStudentDialog} from '@components/recharge-failed-charge-student-dialog/recharge-failed-charge-student-dialog.component';

@Component({
  selector: 'app-student-subscription-page',
  templateUrl: './student-subscription-page.component.html',
  styleUrls: ['./student-subscription-page.component.scss']
})
export class StudentSubscriptionPageComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() programs: Program[];
  @Input() user: User;
  @Input() mode = 'student';
  @Input() usersSubject: Subject<User>;
  @Input() programsSubject: Subject<Program[]>;
  @Input() schoolOwner: User;

  school: School = JSON.parse(localStorage.getItem('school'));
  subscribes = [];
  moveSubscriptionCarousel: Subject<string> = new BehaviorSubject(null);
  refreshSubscriptionCarousel: Subject<string> = new BehaviorSubject(null);
  refreshPayments: Subject<string> = new BehaviorSubject(null);
  subscriptions: BehaviorSubject<Subscription[]> = new BehaviorSubject([]);
  subscriptionsFilter: any[];
  subscriptionsFilterDefault: any[];
  usersActivesubscriptionsIds = [];
  usersNotApprovedSubscriptionsIds = [];
  usersStoppedsubscriptionsIds = [];
  usersSuspendedSubscriptionsIds = [];
  viewDialog;
  confirmStopDialog;
  confirmSubscribeDialog;
  selectedprogramIdDefault = 'all';
  selectedlockinIdDefault = 'all';
  selectedprogramId;
  selectedlockinId;
  leftOffset = 0;
  activeSubs = 0;
  activeSubsOld = 0;
  overduePayments;
  overduePaymentsOld;
  currentSchool;
  selectProgram = [];
  current_school_id;
  current_school: School;
  selectLockin = [
    {
      id: 1,
      name: 'Lock In'
    },
    {
      id: 0,
      name: 'No Lock In'
    },
    {
      id: 'all',
      name: 'all'
    }
  ];
  onboardingRegisterDialog;
  rechargeFailedChargeStudentDialog;

  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private router: Router,
    private programService: ProgramService,
    private paymentService: PaymentService,
    private subscriptionService: SubscriptionService,
    private authStore: Store<AuthReducer.AuthState>,
    private programStore: Store<ProgramReducer.ProgramState>,
    private subscribtionStore: Store<SubscriptionReducer.SubscriptionState>,
    private schoolService: SchoolService,
    // private customCarouselComponent: CustomCarouselComponent,
  ) {

  }
  static openConfirmStopModal(
    subscription: Subscription,
    object,
    dialog: MatDialog,
    paymentService: PaymentService,
    user_id,
    continueSubscription = false,
    cancelSubscription = false,
    isAdmin = false,
    currentUser: any = null,
    schoolId: number = 0,
    useStudentMembershipDialogStyle = false
  ) {
    const subscriptionObj = new Subscription(subscription);
    const studentMembershipDialogConfig = useStudentMembershipDialogStyle
      ? { panelClass: 'student-memberships-confirm-dialog' }
      : undefined;

    let isUserCanNotBeCharged = false;
    if (currentUser && schoolId) {
      isUserCanNotBeCharged = paymentService.checkUserCanNotBeCharged(currentUser.schools, schoolId);
    }

    ConfirmModalComponent.setData = false;
    ConfirmModalComponent.withButtons = true;
    ConfirmModalComponent.insertedObject = object;
    ConfirmModalComponent.source = !continueSubscription ? 'stop_subscription' : 'continue_subscription';
    ConfirmModalComponent.methodDelete =  !continueSubscription ? 'stopSubscription' : 'continueSubscription';
    ConfirmModalComponent.methodDeleteParam = {
      program_id: subscription.program_id,
      subscription_id: subscription.id,
      user_id: user_id,
      type: cancelSubscription ? 'cancel' : !continueSubscription ? 'hold' : 'continue',
    };
    ConfirmModalComponent.actionButtonClass = useStudentMembershipDialogStyle ? 'mkc-page__primary-action' : '';
    ConfirmModalComponent.cancelButtonClass = useStudentMembershipDialogStyle ? 'mkc-page__secondary-action' : '';

    if (cancelSubscription) {
      paymentService
        .getCancelPrice(user_id, subscription.userSubscriptionId)
        .subscribe((resp: {data: number}) => {
          if (useStudentMembershipDialogStyle) {
            ConfirmModalComponent.textModal = 'Would you like to Cancel your Membership?\n\nTerms & Conditions apply.';
          } else if (+resp.data > 0 && !isUserCanNotBeCharged) {
            ConfirmModalComponent.textModal = (isAdmin ? 'Charge from student ' :  'By clicking "Pay" you Agree to be charged $')
              + resp.data + ' and to Cancel your membership now.';
          } else {
            ConfirmModalComponent.textModal = 'Refusing this subscription?';
          }

          if (useStudentMembershipDialogStyle) {
            ConfirmModalComponent.textButton = 'Yes Please';
          } else if (resp.data === 0 || isUserCanNotBeCharged) {
            ConfirmModalComponent.textButton =  'Refuse';
          } else {
            ConfirmModalComponent.textButton = 'Pay';
          }
          ConfirmModalComponent.cancelButtonText = useStudentMembershipDialogStyle ? 'No Thanks' : '';

          ConfirmModalComponent.modalRef = dialog.open(ConfirmModalComponent, studentMembershipDialogConfig);
        });
    } else {
      paymentService
        .getDiscount({
          'subscription_id': subscription.id,
          'userSubscription_id': subscription.userSubscriptionId,
          'price': subscriptionObj.getOnHoldValue()
        })
        .subscribe((resp: {data: number}) => {
          ConfirmModalComponent.textModal = useStudentMembershipDialogStyle && continueSubscription === false ?
            'Would you like to Pause your membership?\n\nTerms and conditions apply.' :
            continueSubscription === false ?
            (+resp.data > 0 && !isUserCanNotBeCharged) ?
              (isAdmin ? 'Student will pay ' :  'By clicking "Pay" you Agree to be charged $')
              + resp.data + ' and to Pause your membership now.' :
              'Hold this subscription?' :
            'Continue Subscription ' + subscription.display_name + ' ?';

          if (useStudentMembershipDialogStyle && continueSubscription === false) {
            ConfirmModalComponent.textButton = 'Yes Please';
          } else if (resp.data === 0 || isUserCanNotBeCharged) {
            ConfirmModalComponent.textButton = !continueSubscription ? 'Hold' : 'Continue';
          } else {
            ConfirmModalComponent.textButton = 'Pay';
          }
          ConfirmModalComponent.cancelButtonText = useStudentMembershipDialogStyle && continueSubscription === false ? 'No Thanks' : '';
          ConfirmModalComponent.modalRef = dialog.open(ConfirmModalComponent, studentMembershipDialogConfig);
        });
    }
  }

  ngOnInit() {
    this.programStore.subscribe(
      resp => {
        this.programs = resp.program.programs;
      }
      );
    setTimeout(() => {
      if (!this.programs || this.programs.length === 0) {
        this.programService.getUsersPrograms().subscribe(
          (resp: {data: Program[]}) => {
            this.programs = resp.data;
            this.programStore.dispatch(new SetPrograms(this.programs));
            if (this.user) {
              this.setSubscribes();
            }
          }
        );
      } else if (this.user) {
          this.setSubscribes();
     }

    }, 5);
    this.subscribes.push( this.subscribtionStore.subscribe(
      (val) => {
        if (val.subscription) {
          if ( String(val.subscription.lastAction) === "UPDATE_SUBSCRIPTION") {
            this.subscriptionService.getByUser(this.user.id).subscribe(
              (resp: {data: Subscription[]}) => {
                this.user.subscriptions = resp.data;
                this.refreshState(this.user);
              }
            );
          }
        }
      }
    ));
    if (this.schoolOwner) {
      setTimeout(() => {
        this.schoolService.getSchool(this.schoolOwner.activeSchool).subscribe(
          (resp: {data: School}) => {
            this.currentSchool = resp.data;
          });
      });
    }
    if (this.programsSubject) {
      this.subscribes.push(this.programsSubject.subscribe(resp => {
        this.programs = resp;
      }));
    }
  }

  paymentsRefresh() {
    this.paymentService.getPaymentsInformation().subscribe(
        (resp: {data: any}) => {
          this.overduePayments = resp.data.overduePayments;
          if (this.overduePayments && this.overduePayments.length > 0) {
            if (!this.overduePaymentsOld) {
            } else {
              let check = false;
              this.overduePayments.map(payment => {
                if (!check) {
                  for (let i = 0; i < this.overduePaymentsOld.length; i++) {
                    if (payment.subscription_id !== this.overduePaymentsOld[i].subscription_id) {
                      // document.querySelectorAll('h2')[1].click();
                      check = true;
                      break;
                    }
                  }
                }
              });
            }
            this.overduePaymentsOld = this.overduePayments;
          }
        });
  }

  ngOnDestroy() {
    this.subscribes.map( subscr => subscr.unsubscribe());
  }

  getProgramName(program_id) {
    if (this.programs) {
      this.programs.map( pr => {
        if (pr.id === program_id) {
          return pr.program_name;
        }
      });
    }
  }

  filterByProgram(event) {
    this.selectedprogramIdDefault = event.value;
    this.selectedprogramId = event.value;
    this.defaultFilter(this.subscriptions.value, true);
    this.refreshSubscriptionCarousel.next('refresh');
  }

  filterByLockin(event) {
    this.selectedlockinId = event.value;
    this.defaultFilter(this.subscriptions.value, true);
    this.refreshSubscriptionCarousel.next('refresh');
  }

  openViewModal(event, subscription: Subscription) {
    if (!event.target.classList.contains('buttons-bottom-continue')) {
      CreateProgramSubscriptionComponent.allSubscriptions = [];
      CreateProgramSubscriptionComponent.source = 'view';
      CreateProgramSubscriptionComponent.sourceEdit = subscription;
      this.viewDialog = this.dialog.open(CreateProgramSubscriptionComponent);
      CreateProgramSubscriptionComponent.modalRef = this.viewDialog;
      this.viewDialog.afterClosed().subscribe(result => {
        this.viewDialog.close();
      });
    }
  }

  tabber(e) {
    const index = Array.from(e.target.parentElement.children).indexOf(e.target);
    const elements = document.querySelectorAll('.item-content');
    document.querySelector('h2.active').classList.remove('active');
    e.target.classList.add('active');
    for (let i = 0; i < elements.length; i++) {
      if (index === i) {
        elements[i].classList.remove('hidden');
      } else {
        elements[i].classList.add('hidden');
      }
    }
  }

  ngAfterViewInit() {
    this.usersSubject.subscribe(
      (val: any) => {
        if (val) {
          this.user = val;
          this.usersActivesubscriptionsIds = [];
          this.usersStoppedsubscriptionsIds = [];
          this.usersSuspendedSubscriptionsIds = [];
          this.usersNotApprovedSubscriptionsIds = [];
          this.user.subscriptions.map( subscr => {
            if (subscr.approved === 1) {
              if (subscr.active === 1 && subscr.deleted_at === null) {
                this.usersActivesubscriptionsIds.push(subscr.id + '|' + subscr.program_id);
              } else if (subscr.active === -1 && subscr.deleted_at === null) {
                this.usersSuspendedSubscriptionsIds.push(subscr.id + '|' + subscr.program_id);
              } else if(subscr.deleted_at === null) {
                this.usersStoppedsubscriptionsIds.push(subscr.id + '|' + subscr.program_id);
              } else {
                this.usersNotApprovedSubscriptionsIds.push(subscr.id + '|' + subscr.program_id);
              }
            } else {
              this.usersNotApprovedSubscriptionsIds.push(subscr.id + '|' + subscr.program_id);
            }
          });
          if (this.programs) {
            this.setSubscriptionsAction();
          }
        }
      }
    );

    this.selectedprogramId = 'all';
  }
  openStripeWindow(subscription: Subscription) {
    const total = +subscription.joining_fee + +subscription.payment_price;
    return new Promise((resolve, reject) => {
      StripeCheckout.configure({
        key: environment.STRIPE_KEY,
        locale: 'auto',
        panelLabel: 'Submit',
        source: async (source) => {
          source.amount = total * 100;
          resolve(source);
        }
      }).open({
        name: 'Mykoolcat',
        description: 'Subscription amount will be charged right away if it does not have trial',
        amount: total * 100,
        currency: 'aud',
        email: this.user.email,
      });
    });
  }
  private isMembershipPaymentCollectionEnabled(): boolean {
    if (this.currentSchool) {
      const val = (this.currentSchool as any).collect_membership_payments_through_mkc;
      if (val === false || val === 0 || val === '0') {
        return false;
      }
      return true;
    }
    if (this.schoolOwner && this.schoolOwner.schools) {
      const activeSchoolId = this.schoolOwner.activeSchool
        ? this.schoolOwner.activeSchool
        : (this.user ? this.user.activeSchool : null);
      const found = (this.schoolOwner.schools as any[]).find(s => s.id === activeSchoolId);
      if (found) {
        const val = found.collect_membership_payments_through_mkc;
        if (val === false || val === 0 || val === '0') {
          return false;
        }
        return true;
      }
    }
    return true;
  }

  trySubscribe(event, subscription: Subscription) {
    event.stopPropagation();
    const action = !subscription.limited ? 'subscribe' : 'send_request';
    const activeSchool = this.schoolOwner.activeSchool ? this.schoolOwner.activeSchool : this.user.activeSchool;
    if (this.paymentService.checkUserCanNotBeCharged(this.user.schools, activeSchool)) {
      this.openConfirmSubscribeSendRequestModal(event, action, subscription);
    } else if (!this.isMembershipPaymentCollectionEnabled()) {
      this.openConfirmSubscribeSendRequestModal(event, action, subscription);
    } else if (this.schoolOwner.stripe_status === 'Enabled') {
      this.checkCardExist(event, subscription);
    } else {
      this.onAddNewCard({subscription: subscription, event: event, action: action});
    }
  }

  checkCardExist(event, subscription: Subscription){
    const action = !subscription.limited ? 'subscribe' : 'send_request';
    if (this.user.stripeCustomerId) {
      ConfirmModalComponent.textModal = 'This student allready has payment card. (**** **** **** ' + this.user.card_digits + ')';
      ConfirmModalComponent.textButton = 'Change card';
      ConfirmModalComponent.withButtons = true;
      ConfirmModalComponent.methodDelete = 'onAddNewCard';
      ConfirmModalComponent.methodDeleteParam = {subscription: subscription, event: event, action: action};
      ConfirmModalComponent.cancelButtonText = 'Use existing card';
      ConfirmModalComponent.insertedObject = this;
      ConfirmModalComponent.methodCancel = 'onUseExistingCard';
      ConfirmModalComponent.methodCancelParam = {subscription: subscription, event: event, action: action};
      this.onboardingRegisterDialog = this.dialog.open(ConfirmModalComponent);
      ConfirmModalComponent.modalRef = this.onboardingRegisterDialog;
    } else {
      this.onAddNewCard({subscription: subscription, event: event, action: action});
    }
  }
  onAddNewCard (params) {
    this.openStripeWindow(params.subscription).then((source) => {
      this.paymentService.addStripeCustomer(this.user.id, this.schoolOwner.id, source).subscribe((res: any) => {
        if (res.data.status === 'success') {
          this.openConfirmSubscribeSendRequestModal(params.event, params.action, params.subscription);
          const user = AuthFacade.getUser();
          if (user.notAdmin) {
            this.authStore.dispatch(new UpdateAuthUser({
              stripeCustomerId: res.data.customer,
              card_digits: res.data.card_digits,
            }));
          }
        }
      }, (error: any) => {
        if (error.error.errors && error.error.errors.status === 'fail') {
          ConfirmModalComponent.textModal = error.error.errors.message;
        } else {
          ConfirmModalComponent.textModal = 'Unknown error';
        }
        ConfirmModalComponent.withButtons = false;
        this.onboardingRegisterDialog = this.dialog.open(ConfirmModalComponent);
        ConfirmModalComponent.modalRef = this.onboardingRegisterDialog;
      });
    });
  }
  onUseExistingCard(params) {
    ConfirmModalComponent.resetProperties();
    this.onboardingRegisterDialog.close();
    setTimeout(() => {
      this.openConfirmSubscribeSendRequestModal(params.event, params.action, params.subscription);
    }, 300);
  }
  openConfirmSubscribeSendRequestModal(event, action: string, subscription: Subscription) {
    event.stopPropagation();
    ConfirmModalComponent.insertedObject = this;
    if (this.schoolOwner.stripe_status === 'Enabled' || (this.user.parent_id && this.mode === 'admin') || !this.isMembershipPaymentCollectionEnabled()) {
      event.preventDefault();
      this.subscriptionService.checkSubscriptionExist(subscription.program_id, this.user.id).subscribe(
          (resp: { data: { exist: boolean } }) => {
            if (resp.data.exist) {
              ConfirmModalComponent.textModal = 'You can\'t subscribe to the more than one program\'s subscription';
              ConfirmModalComponent.withButtons = false;
              this.confirmSubscribeDialog = this.dialog.open(ConfirmModalComponent);
              ConfirmModalComponent.modalRef = this.confirmSubscribeDialog;
            } else {
              ConfirmModalComponent.insertedObject = this;
              ConfirmModalComponent.withButtons = true;
              ConfirmModalComponent.setData = false;
              ConfirmModalComponent.source = action;
              const body = {
                user_id: this.user.id,
                subscription_id: subscription.id,
                program_id: subscription.program_id,
                action: action
              };
              if (subscription.trial_status && subscription.trial_start === 'date' && action === 'subscribe' && subscription.program_id) {
                this.programs.map(pr => {
                  if (pr.id === subscription.program_id && !pr.trial) {
                    ConfirmModalComponent.setData = true;
                    ConfirmModalComponent.sourceSchedule = ProgramClassesComponent.reorganizeSchedule(pr);
                  }
                });
              }
              ConfirmModalComponent.methodDelete = 'subscriptionAction';
              ConfirmModalComponent.methodDeleteParam = body;
              this.confirmSubscribeDialog = this.dialog.open(ConfirmModalComponent);
              ConfirmModalComponent.modalRef = this.confirmSubscribeDialog;
              this.confirmSubscribeDialog.afterClosed().subscribe(result => {
                this.refreshPayments.next('refresh');
                // this.paymentsRefresh();
              });
            }
          }
      );
    } else {
      this.onAddNewCard({subscription: subscription, event: event, action: action});
    }
  }

  openConfirmContinueStopModal(event, subscription: Subscription, continueSubscription = false, cancelSubscription = false, run = true) {
    event.stopPropagation();
    if (run) {
      const activeSchool = this.schoolOwner.activeSchool ? this.schoolOwner.activeSchool : this.user.activeSchool;
      StudentSubscriptionPageComponent.openConfirmStopModal(subscription,
        this, this.dialog, this.paymentService, this.user.id,
          continueSubscription, cancelSubscription, false, this.user, activeSchool, true);
    }
  }
  stopSubscription(body) {
    this.paymentService.payOnholdFee(body).subscribe(
      (resp: any) => {
        switch (resp.data.status) {
          case 'succeeded_before': {
            this.user.subscriptions.map((item, i) => {
              if (item.id === resp.data.subscription_id) {
                this.user.subscriptions[i].active = resp.data.active;
                this.user.subscriptions[i].approved = resp.data.approved;
              }
            });
            this.refreshState(this.user);
            break;
          }
          case 'succeeded': {
            this.subscriptionService.toggleSubscriptionStatus(body).subscribe(
              (resp: { data: {user: User} }) => {
                this.refreshState(resp.data.user);
              }
            );
            break;
          }
          case 'panding': {
            this.subscriptionService.toggleSubscriptionStatus(body).subscribe(
              (resp: { data: {user: User} }) => {
                this.refreshState(resp.data.user);
              }
            );
            break;
          }
          case 'unprocessed': {
            this.subscriptionService.toggleSubscriptionStatus(body).subscribe(
              (resp: { data: {user: User} }) => {
                this.refreshState(resp.data.user);
              }
            );
            break;
          }
          case 'full_discount': {
            this.subscriptionService.toggleSubscriptionStatus(body).subscribe(
              (resp: { data: {user: User} }) => {
                this.refreshState(resp.data.user);
              }
            );
            break;
          }
          case 'canceled_subscription': {
            this.user.subscriptions.map((item, i) => {
              if (item.id === resp.data.subscription_id) {
                this.user.subscriptions.splice(i, 1);
              }
            });
            this.refreshState(this.user);
            break;
          }
          case 'redirect': {
            if (resp.data.url && resp.data.url.length > 0) {
              document.location.replace(resp.data.url);
            } else {
              console.error('Url is required');
            }
            break;
          }
        }
      }, (error) => {
        setTimeout(() => {
          ConfirmModalComponent.textModal = error.error.message;
          ConfirmModalComponent.withButtons = false;
          this.confirmSubscribeDialog = this.dialog.open(ConfirmModalComponent);
          ConfirmModalComponent.modalRef = this.confirmSubscribeDialog;
        }, 500);
      });
  }
  continueSubscription (body) {
    this.subscriptionService
      .toggleSubscriptionStatus(body)
      .subscribe(
      (resp: {data: {user: User}, status: number}) => {
        if (resp.data.user) {
          this.refreshState(resp.data.user);
        }
        // need to pay status
        if (
          resp.status === 11200 &&
          resp.data.user &&
          resp.data.user.systemSubscriptionStatus &&
          resp.data.user.systemSubscriptionStatus.length > 0
        ) {
          const status = resp.data.user.systemSubscriptionStatus[0];
          if (status && status.status !== 'active') {
            this.openRechargeFailedChargeStudentDialog(status);
          }
        } else if (resp.status === 15200) {
          ConfirmModalComponent.textModal = 'Subscription was refused';
          ConfirmModalComponent.withButtons = false;
          ConfirmModalComponent.source = 'info';
          this.confirmSubscribeDialog = this.dialog.open(ConfirmModalComponent);
          ConfirmModalComponent.modalRef = this.confirmSubscribeDialog;
      }
    });
  }

  openRechargeFailedChargeStudentDialog(systemSubscriptionStatus) {
    RechargeFailedChargeStudentDialog.systemSubscriptionStatus = systemSubscriptionStatus;
    this.rechargeFailedChargeStudentDialog = this.dialog.open(RechargeFailedChargeStudentDialog);
    RechargeFailedChargeStudentDialog.modalRef = this.rechargeFailedChargeStudentDialog;
    this.rechargeFailedChargeStudentDialog.afterClosed().subscribe(result => {
      this.rechargeFailedChargeStudentDialog.close();
    });
  }


  suspendSubscription (body) {
    this.subscriptionService
      .suspendSubscription(body)
      .subscribe(resp => {
        //
      });
  }

  subscriptionAction(body: {subscription_id: number, user_id: number, program_id: number, action: string}) {
    switch (body.action) {
      case 'subscribe': {
        this.subscribeToSubscription(body);
        break;
      }
      case 'send_request': {
        this.sendRequestLimitedClass(body);
        break;
      }
      case 'resend_request': {
        this.sendRequestLimitedClass(body);
        break;
      }
    }
  }
  sendRequestLimitedClass(body: {subscription_id: number, user_id: number, program_id: number}) {
    this.subscriptionService.sendRequestLimitedClass(body).subscribe(
      (resp: { data: User }) => {
        this.refreshState(resp.data);
      }
    );
  }
  subscribeToSubscription(body: {subscription_id: number, user_id: number, program_id: number}) {
    this.subscriptionService.addUser(body).subscribe((resp: any) => {
      if (resp.data && resp.data.programLimitReached) {
        ConfirmModalComponent.textModal =
          'You can\'t subscribe to the program, maximum programs count for this subscription is ' + resp.data.count;
        ConfirmModalComponent.source = 'info';
        ConfirmModalComponent.withButtons = false;
        ConfirmModalComponent.modalRef = this.dialog.open(ConfirmModalComponent);
      } else {
          this.refreshState(resp.data);
          this.paymentService.createChargeForProgram(body.program_id, body.subscription_id, body.user_id, 'subscribe')
            .subscribe((res: any) => {
              if (res.status === 'succeeded') {
                if (res.data.amount > 0) {
                  ConfirmModalComponent.textModal = 'Payment was successfully charged';
                } else {
                  ConfirmModalComponent.textModal = 'Subscription activated';
                }
                ConfirmModalComponent.source = 'info';
                ConfirmModalComponent.withButtons = false;
                ConfirmModalComponent.modalRef = this.dialog.open(ConfirmModalComponent);
              }
              this.refreshState(res.data.user);
            }, (error: any) => {
              ConfirmModalComponent.textModal = error.error.errors.message;
              ConfirmModalComponent.source = 'info';
              ConfirmModalComponent.withButtons = false;
              ConfirmModalComponent.modalRef = this.dialog.open(ConfirmModalComponent);

              this.suspendSubscription({
                program_id: body.program_id,
                subscription_id: body.subscription_id,
                user_id: body.user_id,
                lastPage: '/subscriptions',
              });
              // this.stopSubscription({
              //   program_id: body.program_id,
              //   subscription_id: body.subscription_id,
              //   user_id: body.user_id,
              //   type: 'cancel',
              //   lastPage: '/subscriptions'
              // });
            });
        this.setSubscribes();
      }
    });
  }
  checkStopped(program_id, subscription_id = null) {
    let found = true;
    // this.usersStopedSubscriptionsArray.map( item => {
    //   if (item.program_id === program_id) {
    //     if (subscription_id || subscription_id === item.subscription_id)
    //       found = true;
    //   }
    // });
    return found;
  }
  setSubscribes(force = false) {
    if (this.programs.some(p => !p.subscriptions) || force) {
      let ids = [];
      let subscriptionsByProgramIds = {};
      this.programs.map( pr => ids.push(pr.id));

      this.subscriptionService.getAll(ids, this.user.id).subscribe(
        (resp: {data: Subscription[]}) => {
          resp.data.map(sub => {
            if (!subscriptionsByProgramIds[sub.program_id]) {
              subscriptionsByProgramIds[sub.program_id] = [];
            }
            subscriptionsByProgramIds[sub.program_id].push(sub);
          });
          if (Object.keys(subscriptionsByProgramIds).length > 0) {
            Object.keys(subscriptionsByProgramIds).map(pr_id => {
              this.programs.map( pr => {
                if (+pr.id === +pr_id) {
                  pr.subscriptions = subscriptionsByProgramIds[pr_id];
                  this.programStore.dispatch(new UpdateProgram(pr));
                }
              });
            });
            this.setSubscriptionsAction();
          }
        }
      );
    } else {
      this.setSubscriptionsAction();
    }
  }
  splitSchedule(data) {
    data = data.split(" ");
    return data[0];
  }
  setSubscriptionsAction() {
    const subscrIds = [];
    const subscriptions = [];
    this.programs.map( pr => {
      if (pr.subscriptions) {
        pr.subscriptions.map(subscr => {
          if (!subscrIds.includes(subscr.id + '|' + pr.id)) {
            subscr.program_name = pr.program_name;
            subscriptions.push(subscr);
            subscrIds.push(subscr.id + '|' + pr.id);
          }
        });
      }
    });
    this.user.subscriptions.map((subscr, subscrIndex) => {
      subscriptions.map( (subscrS, i) => {
        if (subscrS.id === subscr.id && subscrS.program_id === subscr.program_id) {
          subscrS.active = subscr.active;
          subscrS.approved = subscr.approved;
          subscrS.scheduledStart = subscr.scheduledStart;
          subscrS.renewDate = subscr.renewDate;
          subscrS.startingDate = subscr.startingDate;
          subscrS.expireDate = subscr.expireDate;
          subscrS.classesLeft = subscr.classesLeft;
          subscrS.userId = subscr.userId;
          subscrS.userSubscriptionId = subscr.userSubscriptionId;
          subscrS.is_try_before_you_by = subscr.is_try_before_you_by;

          if (subscr.id && subscrS.userSubscriptionId && subscr.payment_price) {
            this.paymentService.getDiscount({
              'subscription_id': subscrS.id,
              'userSubscription_id': subscrS.userSubscriptionId,
              'price': subscr.payment_price
            }).subscribe(
              (resp: { data: number }) => {
                if (this.user.subscriptions[subscrIndex]) {
                  this.user.subscriptions[subscrIndex].paymentPriceWithDiscount = resp.data;
                }
              }
            );
          }
        }
      });
    });
    this.programs.map( (program, index) => {
      if (!this.selectProgram[index]) {
        this.selectProgram[index] = {};
      }
      this.selectProgram[index].id = program.id;
      this.selectProgram[index].name = program.program_name;
      if (index === this.programs.length - 1) {
        this.selectProgram[index + 1] = {
          id: 'all',
          name: 'All Programs'
        };
      }
    });
    this.subscriptions.next(subscriptions);
    this.defaultFilter(this.subscriptions.value);
  }

  defaultFilter(data, manual = false) {
    const priceFilter = [];
    const finalFilter = [];
    this.activeSubs = 0;

    data.map( subscr => {
      priceFilter.push(Object.assign({}, subscr));
    });
    priceFilter.sort(function(a, b) {
      if(a.payment_price && b.payment_price){
        return parseFloat(a.payment_price.toString()) - parseFloat(b.payment_price.toString());
      }else{
        return parseFloat('0');
      }
    });
    priceFilter.map( subscr => {
      if (this.usersSuspendedSubscriptionsIds.includes(subscr.id + '|' + subscr.program_id)) {
        subscr.activeUser = 1;
      } else {
        subscr.activeUser = 0;
      }
      if (this.usersActivesubscriptionsIds.includes(subscr.id + '|' + subscr.program_id)) {
        subscr.activeUser = 1;
      } else {
        subscr.activeUser = 0;
      }
      if (this.usersStoppedsubscriptionsIds.includes(subscr.id + '|' + subscr.program_id)) {
        subscr.hold = 1;
      } else {
        subscr.hold = 0;
      }
    });
    priceFilter.sort(function(a, b) {
      return b.lockin - a.lockin;
    });
    priceFilter.sort(function(a, b) {
      return b.hold - a.hold;
    });
    priceFilter.sort(function(a, b) {
      return b.activeUser - a.activeUser;
    });
    if (this.selectedprogramId !== undefined && this.selectedprogramId !== 'all') {
      priceFilter.map( subscr => {
        if (subscr.program_id === this.selectedprogramId) {
          subscr.programCheck = 1;
        } else {
          subscr.programCheck = 0;
        }
      });
    } else {
      priceFilter.map( subscr => {
        subscr.programCheck = 1;
      });
    }
    if (this.selectedlockinId !== undefined && this.selectedlockinId !== 'all') {
      priceFilter.map( subscr => {
        if (subscr.lockin === this.selectedlockinId) {
          subscr.lockinCheck = 1;
        } else {
          subscr.lockinCheck = 0;
        }
      });
    } else {
      priceFilter.map( subscr => {
        subscr.lockinCheck = 1;
      });
    }
    priceFilter.map( subscr => {
      if (subscr.programCheck === 1 && subscr.lockinCheck === 1) {
        finalFilter.push(new Subscription(subscr));
      }
    });
    this.subscriptionsFilter = finalFilter;
    this.subscriptionsFilter.map( subscr => {
      if (subscr.activeUser) {
        this.activeSubs += 1;
      }
      if (subscr.hold) {
        this.activeSubs += 1;
      }
    });
    if (this.activeSubs > this.activeSubsOld) {
      this.refreshSubscriptionCarousel.next('refresh');
    }
    this.activeSubsOld = this.activeSubs;
  }

  getDay(value) {
    const weekday = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const mydate = new Date(value);
    return weekday[mydate.getDay()];
  }

  static getOnHoldValue(subscription: Subscription) {
    return subscription.getOnHoldValue();
  }
    // 1alog() {
    //     const dialogRef2 = this.dialog.open(DemoDialog);
    // }
  // openDialog(url: string) {
    // window.open(url, "_blank");
    // const reference = this.dialog.open(TermsComponent);
    // TermsComponent.modalRef = reference;
  // }
  openDialog(condition: boolean = false, e, subscription?: Subscription) {
    if (condition) {
      e.stopPropagation();
      const reference = this.dialog.open(TermsPdfComponent);
      reference.componentInstance.terms_pdf = subscription && subscription.terms_and_conditionals_link ?
        subscription.terms_and_conditionals_link :
        this.school.terms;
      TermsPdfComponent.modalRef = reference;
    } else {
      const reference = this.dialog.open(TermsComponent);
      TermsComponent.modalRef = reference;
    }
  }

  quantity(plan, name, amount) {
    const daysQuantity = {
      year: 365,
      month: 30,
      week: 7,
      day: 1
    };
    return Math.floor(daysQuantity[plan] / daysQuantity[name] / amount);
  }
  parse(value) {
    return parseFloat(value);
  }
  refreshState(user: User) {
    if (this.mode === 'student') {
      this.authStore.dispatch(new UpdateAuthUser(user));
    } else {
      this.usersSubject.next(user);
    }
  }

  getFrequency(subscr: Subscription) {
    if (subscr.isOnDemandType()) {
      return 'on demand';
    }

    let frequency = subscr.frequency_name;
    if (frequency === 'day') {
      frequency = 'dai';
    }

    frequency += 'ly';

    return frequency;
  }
}
// @Component({
//     selector: 'dialog-content-example-dialog',
//     template: `
//     <mat-dialog-content class="mat-typography">
//         <h2 mat-dialog-title>Terms & Conditions</h2>
//         <h3>Develop across all platforms</h3>
//         <p>Learn one way to build applications with Angular and reuse your code and abilities to build
//             apps for any deployment target. For web, mobile web, native mobile and native desktop.</p>
//         <h3>Speed &amp; Performance</h3>
//         <p>Achieve the maximum speed possible on the Web Platform today, and take it further, via Web
//             Workers and server-side rendering. Angular puts you in control over scalability. Meet huge
//             data requirements by building data models on RxJS, Immutable.js or another push-model.</p>
//         <h3>Incredible tooling</h3>
//         <p>Build features quickly with simple, declarative templates. Extend the template language with
//             your own components and use a wide array of existing components. Get immediate Angular-specific
//             help and feedback with nearly every IDE and editor. All this comes together so you can focus
//             on building amazing apps rather than trying to make the code work.</p>
//     </mat-dialog-content>
//     <mat-dialog-actions align="end">
//         <button mat-button mat-dialog-close>OK</button>
//
//     </mat-dialog-actions>`,
// })
// export class DemoDialog{}
